import { addressFrag } from '../../../../service/types/common.types';

export const getAddressFrag = `
    id
    address {
        ${addressFrag}
    }
`;
